import { render, staticRenderFns } from "./RenameXome.vue?vue&type=template&id=8b0be124&"
import script from "./RenameXome.vue?vue&type=script&lang=js&"
export * from "./RenameXome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports